module.exports = __webpack_public_path__ + "img/BM_logo.123e24ef.png";